import { render, staticRenderFns } from "./ConfigurarCertificadoForm.vue?vue&type=template&id=899c8296&scoped=true&"
import script from "./ConfigurarCertificadoForm.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarCertificadoForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurarCertificadoForm.vue?vue&type=style&index=0&id=899c8296&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899c8296",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('899c8296', component.options)
    } else {
      api.reload('899c8296', component.options)
    }
    module.hot.accept("./ConfigurarCertificadoForm.vue?vue&type=template&id=899c8296&scoped=true&", function () {
      api.rerender('899c8296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CertificadosBase/ConfigurarCertificadoForm.vue"
export default component.exports